import "../../components/Landing/Landing.css";
import LandingContent from "../../components/Landing/LandingContent";
const LandingPage = () => {
  return (
    <div id="landing" className="page-col">
      <LandingContent />
    </div>
  );
};

export default LandingPage;
